import {gql} from "@apollo/client";

export default gql`
mutation RemoveWorkTypeRate($removeWorkTypeRateId: Int!) {
    removeWorkTypeRate(id: $removeWorkTypeRateId)
  }
`;
